import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  EmployeeModel,
  EmployeeLiteModel,
  getEmployeeInput,
  getEmployeesInput,
} from './model';

export function useGetEmployees(
  input?: getEmployeesInput,
  options?: UseQueryOptions<ExtendedApiResult<EmployeeLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<EmployeeLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getEmployees', input?.params],
      () => QueryFetchFunction({ url: 'employees', params: input?.params }),
      options,
    ),
    EmployeeLiteModel,
  );
}

export function useGetEmployee(
  input?: getEmployeeInput,
  options?: UseQueryOptions<ApiResult<EmployeeModel>, ApiError>,
): UseQueryResult<ApiResult<EmployeeModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getEmployee', input?.id],
      () =>
        QueryFetchFunction({
          url: `employees/${input?.id}`,
        }),
      options,
    ),
    EmployeeModel,
  );
}

export function getEmployeesKey(input?: getEmployeesInput) {
  return ['getEmployees', input?.params].filter(Boolean);
}

export function getEmployeeKey(input?: getEmployeeInput) {
  return ['getEmployee', input?.id].filter(Boolean);
}
